import { styled } from "styled-components";

import {
  AvatarButton,
  Icon,
  Menu as MenuBase,
  Stack,
} from "@fidelix/fx-miranda";

import { Trans } from "@lingui/react/macro";
import type { Key } from "react-aria-components";
import { config } from "../config";
import { useUserContext } from "../user/user-context";

export function NavMenu() {
  const { user } = useUserContext();

  const handleMenuAction = (id: Key) => {
    if (id === "/me") {
      window.open(`${config.ADMIN_URL}/me`, "_blank");
    }
  };

  return (
    <Menu
      onAction={handleMenuAction}
      trigger={
        <AvatarButton
          name={user?.fullName || ""}
          data-test-id="nav-menu-button"
        />
      }
    >
      <Menu.Item id={"/me"} data-test-id="nav-menu-item-logout">
        <Stack axis="x" spacing="xsmall" align="center">
          <Icon icon="accountFilled" size={18} />
          <Trans>My account</Trans>
        </Stack>
      </Menu.Item>
      <Menu.Item href="/logout" data-test-id="nav-menu-item-logout">
        <Stack axis="x" spacing="xsmall" align="center">
          <Icon icon="logOut" size={18} />
          <Trans>Logout</Trans>
        </Stack>
      </Menu.Item>
    </Menu>
  );
}

const Menu = styled(MenuBase)`
  min-width: 250px;
`;
